// extracted by mini-css-extract-plugin
module.exports = {"label":"suggestions_label__sZQbk","list":"suggestions_list__wEgIO","link":"suggestions_link__PRBtH"};